import React, { useState, useEffect } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { withStyles, CircularProgress, Typography, Box } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import Dashboard from '../../../../layouts/Dashboard';
import CreateLocationPrinters from '../../../../components/Global/LocationPrinters/Create';

import { createLocationPrintersInitQuery, Location } from './queries';

import styles from './styles';
interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const LocCreateLocationPrinters = ({ classes, history }: Props): React.ReactElement => {
  const { enqueueSnackbar } = useSnackbar();
  const [location, setLocation] = useState<Location>({
    name: '',
    organisation: {
      menus: [],
    },
    devices: [],
  });

  const { data: locationUserInitData, loading, error } = useQuery(createLocationPrintersInitQuery(), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && locationUserInitData && locationUserInitData.locations && locationUserInitData.locations.length > 0) {
      setLocation(locationUserInitData.locations[0]);
    }
    return () => {
      mounted = false;
    };
  }, [locationUserInitData]);

  useEffect(() => {
    if (error) {
      enqueueSnackbar('Failed to load location data. Please try again.', { variant: 'error' });
    }
  }, [error, enqueueSnackbar]);

  const handleFinish = () => {
    history.push(`/loc/printers`);
  };

  if (loading) {
    return (
      <Dashboard breadcrumbs={[{ label: 'Printers', link: `/loc/printers` }, { label: 'Create' }]}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Dashboard>
    );
  }

  if (error) {
    return (
      <Dashboard breadcrumbs={[{ label: 'Printers', link: `/loc/printers` }, { label: 'Create' }]}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <Typography color="error">Error loading location data: {error.message}</Typography>
        </Box>
      </Dashboard>
    );
  }

  if (!locationUserInitData || !locationUserInitData.locations || locationUserInitData.locations.length === 0) {
    return (
      <Dashboard breadcrumbs={[{ label: 'Printers', link: `/loc/printers` }, { label: 'Create' }]}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <Typography>No location data available. Please contact your administrator.</Typography>
        </Box>
      </Dashboard>
    );
  }

  return (
    <>
      <Dashboard breadcrumbs={[{ label: 'Printers', link: `/loc/printers` }, { label: 'Create' }]}>
        <CreateLocationPrinters
          locations={location.devices?.map((d) => d.device_config?.location).filter(Boolean) || []}
          menus={location.organisation?.menus || []}
          handleFinish={handleFinish}
        />
      </Dashboard>
    </>
  );
};

export default withRouter(withStyles(styles)(LocCreateLocationPrinters));
